import { PermissionType } from 'src/pages/budget/budgetTeams/types'
import { Product, TStatus, TStatusPeriod } from 'src/pages/budget/types'

export const STAGES: PermissionType[] = ['submit', 'approve', 'pay']

export const BUDGET_STEPS: Record<PermissionType, string> = {
  submit: 'Подача бюджета',
  approve: 'Согласование бюджета',
  pay: 'Оплата бюджета команды',
} as const

export const PARENT_COLORS = [
  'var(--color-green-30)',
  'var(--color-ligthblue-30)',
  'var(--color-orange-30)',
  'var(--color-blue-30)',
] as const

export const CHILD_COLORS = [
  'var(--color-green-10)',
  'var(--color-ligthblue-10)',
  'var(--color-orange-10)',
  'var(--color-blue-10)',
] as const

export const PRODUCT_OPTIONS: { label: string; value: Product }[] = [
  { label: 'Headway', value: 'headway' },
  { label: 'Nova', value: 'nova' },
  { label: 'Find Guide', value: 'findGuide' },
]

export const FREQUENCY_OPTIONS = [
  { label: 'Ежемесячно', value: 'month', style: { fontSize: 18 } },
  { label: 'Каждые 6 месяцев', value: 'halfYear', style: { fontSize: 18 } },
  { label: 'Каждый год', value: 'year', style: { fontSize: 18 } },
]

export const CURRENCY_OPTIONS = [
  {
    label: 'USD',
    value: 'USD',
  },
  {
    label: 'EUR',
    value: 'EUR',
  },
  {
    label: 'IDR',
    value: 'IDR',
  },
  {
    label: 'THB',
    value: 'THB',
  },
  {
    label: 'JPY',
    value: 'JPY',
  },
  {
    label: 'ZAR',
    value: 'ZAR',
  },
  {
    label: 'BRL',
    value: 'BRL',
  },
  {
    label: 'MYR',
    value: 'MYR',
  },
  {
    label: 'NGN',
    value: 'NGN',
  },
]

export const labelStyle = {
  width: '25%',
  fontSize: 18,
}

export const cardStyles = {
  header: {
    fontSize: '20px',
    backgroundColor: 'var(--color-gray-30)',
  },
}

export const iconButtonStyle = {
  cursor: 'pointer',
}

export const PRODUCT_MAP: Record<string, string> = {
  headway: 'Headway',
  nova: 'Nova',
  findGuide: 'Find Guide',
}

export const STATUS_MAP_NAME: Record<TStatus, string> = {
  draft: 'Черновик',
  submitted: 'На согласовании',
  in_review: 'На проверке',
  approved: 'Принято',
  rejected: 'Отклонено',
  pending_payment: 'Ожидает оплаты',
  partial_payment: 'Частично оплачено',
  paid: 'Оплачено',
  expired: 'Истекла',
}

export const STATUS_OPTIONS = Object.entries(STATUS_MAP_NAME).map(
  ([key, value]) => ({
    value: key as TStatus,
    label: value,
  }),
)

export const STATUS_MAP_COLOR: Record<TStatus, string> = {
  draft: 'default',
  submitted: 'cyan-inverse',
  in_review: 'yellow-inverse',
  approved: 'green-inverse',
  rejected: 'red-inverse',
  pending_payment: 'blue',
  partial_payment: 'gold',
  paid: 'blue-inverse',
  expired: 'volcano-inverse',
}

export const STATUS: Record<string, TStatus> = {
  DRAFT: 'draft',
  SUBMITTED: 'submitted',
  IN_REVIEW: 'in_review',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  PENDING_PAYMENT: 'pending_payment',
  PARTIAL_PAYMENT: 'partial_payment',
  PAID: 'paid',
  EXPIRED: 'expired',
} as const

export const STATUS_PERIOD: Record<string, TStatusPeriod> = {
  OPEN_CREATE: 'open_create',
  CLOSE_CREATE: 'close_create',
  OPEN_PAYMENT: 'open_payment',
  CLOSED: 'closed',
} as const

export const STATUS_PERIOD_LABELS: Record<TStatusPeriod, string> = {
  open_create: 'Открыт для подачи заявок',
  close_create: 'Закрыт для подачи заявок',
  open_payment: 'Открыт для оплаты',
  closed: 'Закрыт',
}

export const STATUS_PERIOD_COLOR: Record<TStatusPeriod, string> = {
  open_create: 'cyan-inverse',
  close_create: 'orange-inverse',
  open_payment: 'green-inverse',
  closed: 'red-inverse',
}

export const REQUIRED_FIELD = '*Обязательное поле'
export const POSITIVE_DECIMAL_PATTERN = /^(?=.*[1-9])\d+([.,]\d{1,18})?$/
export const POSITIVE_DECIMAL_MESSAGE =
  'Укажите положительное число: не более 18 знаков после запятой; разделитель . или ,'

export const CEO_NAME_TEAM = 'CEO'
